export const isValidPrd = (value: string): boolean => /^PRD-[A-Z0-9]{7,}$/i.test(value.trim());
